import { render, staticRenderFns } from "./ServiceRecordStep2.vue?vue&type=template&id=597124c6&scoped=true"
import script from "./ServiceRecordStep2.vue?vue&type=script&lang=js"
export * from "./ServiceRecordStep2.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecordStep2.vue?vue&type=style&index=0&id=597124c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597124c6",
  null
  
)

export default component.exports